module.exports = __webpack_public_path__ + "/images/logo-af-maisons.f410f98.svg";